var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtAlertCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2ZM26 16C26 14.8954 25.1046 14 24 14C22.8954 14 22 14.8954 22 16V24C22 25.1046 22.8954 26 24 26C25.1046 26 26 25.1046 26 24V16ZM24 30C22.8954 30 22 30.8954 22 32C22 33.1046 22.8954 34 24 34H24.02C25.1246 34 26.02 33.1046 26.02 32C26.02 30.8954 25.1246 30 24.02 30H24Z",
    fill: "#D92D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtAlertCircleFilled);
export default __webpack_public_path__ + "static/media/at_alert-circle-filled.8441f53387e3851d640989feee0a43e2.svg";
export { ForwardRef as ReactComponent };